// Hamburger menu toggle
const hamburger = document.getElementById("hamburger");
const navMenu = document.getElementById("navMenu");

if (hamburger && navMenu) {
  hamburger.addEventListener("click", () => {
    hamburger.classList.toggle("active");
    navMenu.classList.toggle("active");
  });

  // Close menu when clicking on a link
  document.querySelectorAll(".nav-menu a").forEach((link) => {
    link.addEventListener("click", () => {
      hamburger.classList.remove("active");
      navMenu.classList.remove("active");
    });
  });

  // Close menu when clicking/tapping on the menu overlay
  navMenu.addEventListener("click", (e) => {
    if (e.target === navMenu) {
      hamburger.classList.remove("active");
      navMenu.classList.remove("active");
    }
  });

  // Close menu when pressing Escape
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && navMenu.classList.contains("active")) {
      hamburger.classList.remove("active");
      navMenu.classList.remove("active");
    }
  });
}

// 1. Show or hide the date step
function toggleDateInput() {
  const needsDate =
    document.querySelector('input[name="start-now"]:checked')?.value === "no";
  const dateInput = document.getElementById("date");

  document.getElementById("date-step").style.display = needsDate
    ? "block"
    : "none";
  dateInput.required = needsDate;

  if (!needsDate) {
    dateInput.value = "";
    dateInput.removeAttribute("aria-invalid");
    document.getElementById("date-error").textContent = "";
  }
}

// 2. Format the date while typing
function formatDate(input) {
  const digitsBeforeCaret = input.value
    .slice(0, input.selectionStart)
    .replace(/\D/g, "").length;

  const digits = input.value.replace(/\D/g, "").slice(0, 8);
  const formatted = [digits.slice(0, 2), digits.slice(2, 4), digits.slice(4)]
    .filter(Boolean)
    .join("/");

  if (input.value === formatted) return;
  input.value = formatted;

  // Caret position after n digits in "DD/MM/YYYY"
  const n = Math.min(digitsBeforeCaret, digits.length);
  const pos = n <= 2 ? n : n <= 4 ? n + 1 : n + 2;
  input.setSelectionRange(pos, pos);
}

// 3. Validate the finished date (called from the input's onblur)
function isValidFutureStartDate(input) {
  const match = String(input)
    .trim()
    .match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
  if (!match) return { valid: false, reason: "Format must be DD/MM/YYYY" };

  const [day, month, year] = match.slice(1).map(Number);
  if (year < 1900) {
    return { valid: false, reason: "Year must be 1900 or later" };
  }

  // Catch MM/DD/YYYY transposition (e.g. 12/30/2026 -> day=12, month=30)
  if (month > 12 && day <= 12) {
    return {
      valid: false,
      reason: "Day comes first: use DD/MM/YYYY (e.g. 30/12/2026)",
    };
  }

  if (month < 1 || month > 12) {
    return { valid: false, reason: "Invalid month (must be 01-12)" };
  }

  const date = new Date(year, month - 1, day);
  if (
    date.getFullYear() !== year ||
    date.getMonth() !== month - 1 ||
    date.getDate() !== day
  ) {
    return { valid: false, reason: "Date does not exist on the calendar" };
  }

  const today = new Date();
  today.setHours(0, 0, 0, 0);
  if (date < today) {
    return {
      valid: false,
      reason: "Start date must be today or in the future",
    };
  }

  return { valid: true, date };
}
